import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.227 13.008c.291.129.595.21.898.28v11.107a3 3 0 0 1-.548-.198l-7-3.115A3.5 3.5 0 0 1 3.5 17.885v-7.77c0-.315.047-.63.128-.922zm5.063-2.601L7.782 5.938l-2.205.98a3.4 3.4 0 0 0-1.062.735l8.412 3.745a2.65 2.65 0 0 0 2.146 0zm6.195-2.754a3.4 3.4 0 0 0-1.062-.735l-7-3.115a3.46 3.46 0 0 0-2.846 0l-2.672 1.19 9.508 4.469zm.887 1.54-4.095 1.82v2.859a.88.88 0 0 1-.875.875.88.88 0 0 1-.875-.875v-2.089l-2.754 1.225c-.291.117-.595.21-.898.28v11.107c.187-.047.373-.117.548-.198l7-3.115a3.5 3.5 0 0 0 2.077-3.197v-7.77c0-.315-.047-.63-.128-.922"
    }, null, -1)
  ])))
}
export default { render: render }